import * as types from './actionTypes';
import api from 'api/';

export function getData() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const contributorData = await api.getContributorDetails();
      const myDraftEateries = await api.getMyDrafts(10, 0, "EATERY");
      const myDraftStories = await api.getMyDrafts(10, 0, "STORY");
      const myDraftListicles = await api.getMyDrafts(10, 0, "LISTICLE");
      const myPublishedEateries = await api.getMyPublished(10, 0, "EATERY");
      const myPublishedStories = await api.getMyPublished(10, 0, "STORY");
      const myPublishedListicles = await api.getMyPublished(10, 0, "LISTICLE");
      const myFollowers = await api.getMyFollowers(10, 0);
      const iFollow = await api.getIFollow(10, 0);
      dispatch({
        type: types.LOADED,
        contributorData,
        myDraftEateries,
        myDraftStories,
        myDraftListicles,
        myPublishedEateries,
        myPublishedStories,
        myPublishedListicles,
        myFollowers,
        iFollow
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function loadPaginatedData(listName, flagName, offsetName, apiName, len, offset, arg1) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADINGPAGEDATA,
      listName,
      flagName
    });
    try {
      const pageData = await api[apiName](len, offset, arg1);
      dispatch({
        type: types.LOADEDPAGEDATA,
        listName,
        pageData,
        flagName,
        offsetName,
        offset
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function deleteArticle(data) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.DELETING
    });
    try {
      await api.deleteArticle(data.resourceType, data.id);
      dispatch({
        type: types.DELETED
      });
    } catch (error) {
      console.log(error);
    }
  };
}
